import React from "react";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import AuthDialog from "@/components/AuthDialog";
import SeoHelmet from "./SeoHelmet";

const Layout = ({ children }) => {
  return (
    <>
      <Header />
      <SeoHelmet />
      <main className="flex-grow container mx-auto px-4 sm:px-6 lg:px-8 py-8">
        {children}
      </main>
      <Footer />
      <AuthDialog />
    </>
  );
};

export default Layout;
